export const filtersByGroupsScheme = [
  { key: 'statuses' },
  { key: 'failedReason' },
  {
    key: 'buyerOrderDateRange',
    childs: [{ key: 'buyerOrderDateFrom' }, { key: 'buyerOrderDateTo' }],
  },
  { key: 'selectedSellerAccounts' },
  {
    key: 'destinationPriceRange',
    childs: [{ key: 'destinationPriceFrom' }, { key: 'destinationPriceTo' }],
  },
  { key: 'profit', childs: [{ key: 'profitFrom' }, { key: 'profitTo' }] },
  { key: 'paypalAccountCode' },
  {
    key: 'estimatedShippingTimeRange',
    childs: [{ key: 'estimatedShippingTimeFrom' }, { key: 'estimatedShippingTimeTo' }],
  },
  { key: 'ebayGlobalShippingProgram' },
  { key: 'lateShipment' },
];
